import api from '@/utils/axios';

/**
 * 거래 관련 API 서비스
 * - 거래 내역 조회
 * - 거래 파일 업로드
 * - 거래 폐기
 * - 거래 분석 및 새로고침
 */
const transactionService = {
  // ================================
  // 거래 내역 조회 API
  // ================================
  
  /**
   * 최근 거래 내역 조회 (새로운 API 스펙)
   * @param {string} creditType - 채권 유형 ID
   * @param {number} minMonths - 최소 만기 개월
   * @param {number} maxMonths - 최대 만기 개월
   * @param {string} searchKeyword - 검색 키워드 (선택사항)
   * @param {number} businessDays - 영업일 수 (기본값: 10)
   */
  async inquiry(creditType, minMonths, maxMonths, searchKeyword = null, businessDays = 10) {
    try {
      const queryParams = new URLSearchParams();
      queryParams.append('creditType', creditType);
      queryParams.append('businessDays', businessDays);
      
      if (minMonths !== undefined && minMonths !== null) {
        queryParams.append('minMonths', minMonths);
      }
      if (maxMonths !== undefined && maxMonths !== null) {
        queryParams.append('maxMonths', maxMonths);
      }
      if (searchKeyword && searchKeyword.trim()) {
        queryParams.append('searchKeyword', searchKeyword.trim());
      }

      const data = await api.get(`/api/v1/transaction/recent?${queryParams.toString()}`);
      return data;
    } catch (error) {
      console.error('거래 내역 조회 실패:', error);
      throw error;
    }
  },

  async getRecentTransactions(params) {
    try {
      const queryParams = new URLSearchParams();
      queryParams.append('creditType', params.creditType);
      
      if (params.businessDays) queryParams.append('businessDays', params.businessDays);
      if (params.minMonths) queryParams.append('minMonths', params.minMonths);
      if (params.maxMonths) queryParams.append('maxMonths', params.maxMonths);
      if (params.searchKeyword) queryParams.append('searchKeyword', params.searchKeyword);

      const data = await api.get(`/api/v1/transaction/recent?${queryParams.toString()}`);
      return data;
    } catch (error) {
      console.error('최근 거래 내역 조회 실패:', error);
      throw error;
    }
  },


  // ================================
  // 거래 파일 업로드 API
  // ================================
  async uploadTransactionFile(date, fileName, bondType, file) {
    try {
      const formData = new FormData();
      formData.append('file', file);
      
      const response = await api.postFormData(
        `/api/v1/upload/transaction?date=${date}&fileName=${fileName}&bondType=${bondType}`,
        formData
      );
      return response;
    } catch (error) {
      console.error('거래 파일 업로드 실패:', error);
      throw error;
    }
  },

  // ================================
  // 거래 관리 API
  // ================================
  async discardTransaction(transactionId, reason) {
    try {
      await api.post(`/api/v1/transaction/${transactionId}`, {
        reason,
      });
    } catch (error) {
      console.error('거래 폐기 실패:', error);
      throw error;
    }
  },

  // ================================
  // 거래 분석 및 새로고침 API
  // ================================
  async refreshTransactions(date, bondType) {
    try {
      const response = await api.post(`/api/v1/transaction/refresh?date=${date}&bondType=${bondType}`);
      return response;
    } catch (error) {
      console.error('거래 분석 새로고침 실패:', error);
      throw error;
    }
  },

  async refreshTransactionFromExcel(date, bondType) {
    try {
      const response = await api.post(`/api/v1/transaction/refresh/excel?date=${date}&bondType=${bondType}`);
      return response;
    } catch (error) {
      console.error('거래내역 분석 실패:', error);
      throw error;
    }
  },
};

export default transactionService;
